<template>
  <div class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">{{pageTitle}}</h3>
            <div class="box-tools pull-right" style="display: flex;align-items: center;">
              <page-add @finish="finish">新增</page-add>
              <el-button type="primary">导入</el-button>
              <el-button type="primary">模板下载</el-button>
            </div>
          </div>
          <div class="box-body">
            <el-card class="box-card" shadow="never">
              <div class="query">
                <el-form :inline="true">

                  <el-form-item label="激活状态">
                    <el-select v-model="query.active_status" placeholder="激活状态">
                      <el-option v-for="(item, i) in activeList" :key="i" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="到期状态">
                    <el-select v-model="query.expire_status" placeholder="到期状态">
                      <el-option v-for="(item, i) in expireList" :key="i" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="查询条件">
                    <el-select v-model="query.search_type" placeholder="查询条件">
                      <el-option v-for="(item, i) in searchTypeList" :key="i" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-input v-model="query.keyword" placeholder="输入对应条件信息"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" :disabled="loading" @click="querySearch">查询</el-button>
                  </el-form-item>
                </el-form>
              </div>

              <el-table :data="list" border style="width: 100%" v-loading="loading">
                <el-table-column prop="iccid" label="ICCID" width="200"></el-table-column>
                <el-table-column prop="card_number" label="卡号" width="140"></el-table-column>
                <el-table-column prop="device_unique" label="设备唯一码"></el-table-column>
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.active_name === '已激活'" type="success">{{scope.row.active_name}}</el-tag>
                    <el-tag v-else type="info">{{scope.row.active_name}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="usage" label="本月用量(mb)"></el-table-column>
                <el-table-column prop="imei" label="imei" width="160"></el-table-column>
                <el-table-column prop="whither" label="备注"></el-table-column>
                <el-table-column prop="active_at" label="激活时间" width="140"></el-table-column>
                <el-table-column prop="expire_at" label="到期时间" width="140"></el-table-column>
                <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                    <div style="display: flex;align-items: center;">
                      <page-edit-status :param="scope.row" @finish="finish">
                        状态修改
                      </page-edit-status>
                      <page-edit :param="scope.row" @finish="finish">
                        编辑
                      </page-edit>
                      <page-detail :param="scope.row">
                        详情
                      </page-detail>
                      <page-delete :param="scope.row" @finish="finish">
                        删除
                      </page-delete>
                    </div>
                  </template>
                </el-table-column>
              </el-table>

              <div v-if="list.length > 0">
                <div style="height: 20px;"></div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :current-page="query.page"
                    :page-size="query.size"
                    :total="total"
                    @current-change="pageSelect"
                >
                </el-pagination>
              </div>

            </el-card>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {mapState} from "vuex";

import PageAdd from '@/views/goods/sim/Add.vue';
import PageEdit from "@/views/goods/sim/Edit.vue";
import PageEditStatus from "@/views/goods/sim/EditStatus.vue";
import PageDetail from "@/views/goods/sim/Detail.vue";
import PageDelete from "@/views/goods/sim/Delete.vue";

export default {
  components: {
    PageAdd,
    PageEdit,
    PageDelete,
    PageEditStatus,
    PageDetail
  },
  data() {
    return {
      loading: false,
      query: {
        active_status: -1,
        expire_status: 0,
        search_type: 0,
        keyword: '',
        page: 1,
        size: 10
      },
      list: [],
      total: 0,
      canNext: false,
      nextPage: 1,
      activeList: [],
      expireList: [],
      searchTypeList: [],
    };
  },
  computed: mapState({
    config: (state) => state.config,
    pageTitle: (state) => state.pageTitle,
  }),
  mounted() {
    const _this = this;
    _this.query = Object.assign(_this.query, _this.$route.query)
    _this.query.page = parseInt(_this.query.page);
    _this.query.size = parseInt(_this.query.size);
    _this.query.active_status = parseInt(_this.query.active_status);
    _this.query.expire_status = parseInt(_this.query.expire_status);
    _this.query.search_type = parseInt(_this.query.search_type);
    _this.loading = true;
    _this.$store
        .dispatch('authInit', _this)
        .then(() => {
          _this.loadSelect();
        })
        .catch(() => {
          _this.loading = false;
        })
  },
  methods: {
    updateUrl() {
      const _this = this;
      const url = _this.$queryUrl(_this.$route.path, _this.query);
      _this.$router.replace({path: url});
    },
    querySearch() {
      const _this = this;
      _this.query.page = 1;
      _this.loading = true;
      _this.loadList();
    },
    pageSelect(page) {
      const _this = this;
      _this.query.page = parseInt(page);
      _this.loading = true;
      _this.loadList();
    },
    loadSelect() {
      const _this = this;
      _this.$apiAdmin.adminSimListDetail()
          .then(res => {
            _this.activeList = res.active_list;
            _this.expireList = res.expire_list;
            _this.searchTypeList = res.search_type_list;
            _this.loadList();
          })
          .catch(err => {
            _this.loading = false;
            _this.updateUrl();
          })
    },
    loadList() {
      const _this = this;
      _this.$apiAdmin.adminSimList(_this.query)
          .then(res => {
            _this.loading = false;
            _this.list = res.list;
            _this.total = res.total;
            _this.canNext = res.can_next;
            _this.nextPage = res.next_page;
            _this.updateUrl();
          })
          .catch(err => {
            _this.loading = false;
            _this.updateUrl();
          })
    },
    finish(res) {
      const _this = this;
      _this.loading = true;
      _this.loadList();
    }
  }
}
</script>


<style scoped>
.custom-tree-node {
  display: flex;
  justify-content: space-between;
}

.custom-tree-node-name {
  width: 400px;
}
</style>